import type { AbstractOption } from '~shared/types/abstract-option';

const options = [
  {
    value: 'EVERY_WEEK',
    title: 'Every week',
  },
  {
    value: 'EVERY_TWO_WEEKS',
    title: 'Every two weeks',
  },
  {
    value: 'EVERY_MONTH',
    title: 'Every month',
  },
  {
    value: 'LESS_THAN_ONCE_A_MONTH',
    title: 'Less than once a month',
  },
] as const;

export type OFWIncomeFrequencyValue = (typeof options)[number]['value'];
export const ofwIncomeFrequencyOptions =
  options as unknown as AbstractOption<OFWIncomeFrequencyValue>[];
